import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss'],
})
export class DemoComponent implements OnInit {
  dateStrings: string[] = [];
  mockHtmlContent =
    '<h2>Important notice</h2>' +
    '<p>Oversea-Chinese Banking Corporation Limited (“OCBC Bank”) is an exempt financial adviser and is permitted under the Financial Advisers Act (Cap. 110) (“FAA”) to provide financial advisory services on investment products including but not limited to structured deposits, structured products, structured notes, securities and dual currency investments.</p>' +
    '<p>Your Treasury Advisor is permitted under the FAA to provide financial advisory services on investment products including but not limited to structured deposits, structured products, structured notes, securities and dual currency investments. For avoidance of doubt, your Treasury Advisor is not permitted to (a) advise on futures contract; (b) advise on or arrange life policies; and (c) issue research reports concerning investment products.</p>' +
    '<a href="https://www.google.com" target="_blank">Go to Google</a>';
  samplePDFLocalURL = './assets/pdf/dummy.pdf';
  samplePDFExternalURL =
    'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf';

  constructor(private modalService: NgbModal) {}

  openModal(content: any) {
    this.modalService
      .open(content, { size: 'lg', scrollable: true })
      .result.then(
        (result) => {},
        (reason) => {},
      );
  }

  ngOnInit(): void {
    let today = new Date();
    let seconds = 1000; // number of milliseconds in a second
    let minutes = 60000; // number of milliseconds in a minute
    let hours = 3600000; // number of milliseconds in an hour
    let days = 86400000; // number of milliseconds in a day
    this.dateStrings = [
      new Date(),
      new Date(today.getTime() - 15 * seconds), // 15 seconds ago
      new Date(today.getTime() - 30 * seconds), // 30 seconds ago
      new Date(today.getTime() - 45 * seconds), // 45 seconds ago
      new Date(today.getTime() - minutes), // 1 minute ago
      new Date(today.getTime() - 5 * minutes), // 5 minutes ago
      new Date(today.getTime() - 10 * minutes), // 10 minutes ago
      new Date(today.getTime() - 15 * minutes), // 15 minutes ago
      new Date(today.getTime() - 30 * minutes), // 30 minutes ago
      new Date(today.getTime() - hours), // 1 hour ago
      new Date(today.getTime() - days), // 1 day ago
    ].map((d) => d.toString());
  }

  downloadPDFLocal() {
    this.downloadPDF(this.samplePDFLocalURL);
  }

  downloadPDFExternal() {
    this.downloadPDF(this.samplePDFExternalURL);
  }

  downloadPDF(url: string) {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    link.setAttribute('download', `dummy.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
